'use strict';

export default {
  emailModel: [],//邮件模板
  emailSender: [],//发件人
  emailBalance: {},//邮件使用情况
  emailReport: {}//邮件报告
};



// WEBPACK FOOTER //
// ./src/store/modules/email/state.js